import './style.css'
import { Game } from './Game';

new Game();


